import {defaultTheme} from 'sletat-ui-components2/dist/theme';

export const styles = {
    container : {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      },

      img : {
        height: '100%',
        width: '100%',
        background: 'linear-gradient(180deg,rgba(0, 0, 0, 0.3) 0%,rgba(0, 0, 0, 0.2) 100%)'
      },

      defaultPicture : {
        width: '100%',
        height: '100%',
        backgroundImage: 'url(\'https://static.sletat.ru/images/placeholder/tour/640x356.jpg\')',
        backgroundSize: '100% 100%',
        objectFit: 'cover'
      },

      hideMe : {
        display: 'none'
      },

      sliderPhoto : {
        position: 'relative',
        borderRadius: defaultTheme.theme.borderRadiusVariables.main,
        width: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        objectFit: 'cover',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundColor: '#f3f9ff',

        '&::after': {
            content: '',
            position: 'absolute',
            zIndex: 1,
            display: 'block',
            height: '100%',
            width: '100%',
            backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 100%)'
        }
      }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
